<template>
  <div class="SayfaContainer">
    <div class="SayfaBaslik">
      <h1>Fatura İşlemleri</h1>
      <div class="SayfaBtn el-button-group">
        <el-button size="small" type="info" @click="SayfaYukle" :disabled="lo">yenile</el-button>
        <el-button size="small" type="primary" @click="YeniModalDurum=true" :disabled="lo">Fatura Ekle</el-button>
      </div>
    </div>
    <div class="SayfaIcerik SayfaTable" v-loading="lo">
      <el-table
          v-if="Liste"
          class="table-xs table-hover"
          :data="Liste.filter(data => !Kelime || data.adi.toLowerCase().includes(Kelime.toLowerCase()))"
          @current-change="TableSecim"
          :height="Height">
        <el-table-column label="Fatura No" prop="id" width="85"></el-table-column>
        <el-table-column label="Bina / Cari Adı" prop="adi"></el-table-column>
        <el-table-column label="Fiyat" prop="fiyat" width="200"></el-table-column>
        <el-table-column label="Fatura Türü" prop="tur" width="200"></el-table-column>
        <el-table-column
            align="right" label="Bolge" prop="Grup" width="250" class-name="tablearama">
          <template slot="header" slot-scope="scope">
            <el-input
                v-model="Kelime"
                size="mini"
                class="tablearamainput"
                placeholder="Arama Yapın"/>
          </template>
        </el-table-column>
      </el-table>
    </div>
    <YeniFatura :Bilgi="null" Tur="Post" :Durum="YeniModalDurum" @Durum="SayfaYukle"></YeniFatura>
  </div>
</template>

<script>
import YeniFatura from "./Comp/yeni";

export default {
  components: {YeniFatura},
  data() {
    return {
      lo: false,
      YeniModalDurum: false,
      Kelime: "",
      Height: null,
      Liste: null
    }
  },
  methods: {
    TableSecim(e) {
      //this.$router.push('/bina/' + e.id)
    },
    SayfaYukle() {
      this.lo = true
      this.YeniModalDurum = false
      this.$store.dispatch("Get", {path: 'fatura'})
          .then(response => {
            if (response.Durum === "OK") {
              this.Liste = response.Data
              this.lo = false
            } else {
              this.$notify.error({
                title: response.Mesaj,
                customClass: 'error'
              });
              this.lo = false
            }
          })
    }
  },
  created() {
    this.$store.dispatch("title", "Fatura İşlemleri");
    this.SayfaYukle();
    this.Height = window.innerHeight - 111
  }
}
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/pages/fatura/liste.vue